import { TableRow } from '@mui/material';
import React from 'react';
import { useInView } from "react-intersection-observer";

function TableItemWrapper({ height, children }) {
  const [ref, inView] = useInView();
  const style = {
    height: `${height}px`,
    overflow: 'hidden'
  };
  return (
    <TableRow
      ref={ref}
      style={style}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      {inView ? children : null}
    </TableRow>
  );
}

export default TableItemWrapper;